import {AbTestEventEventData} from '@cube/tracking-library-api';
import {trackABTest as trackABTestCube} from '../../../scripts/service/cube-tracking-layer.js';
import {track} from '../../../scripts/service/generic-tracking-layer.js';

export const trackABTests = () => {
  const activeABTests = getData();
  if (activeABTests && activeABTests.length > 0) {
    activeABTests.forEach(trackABTest);
  }
};

const trackABTest = (abTestData: AbTestEventEventData) => {
  trackABTestCube(abTestData);
  track({
    event: 'testing.userAssigned',
    testing_name: abTestData.event_context,
    testing_variant: abTestData.event_content[0],
    testing_domain: 'ents',
  });
};

const getData = () => {
  const dataNode = document.querySelector<HTMLElement>('#ents-ab-test-tracking');
  if (dataNode) {
    try {
      return JSON.parse(dataNode.innerText);
    } catch (e) { // eslint-disable-line @typescript-eslint/no-unused-vars
      // invalid json
    }
  }
  return [];
};
